module.exports = __webpack_public_path__ + "media/promo/velle/images/products_back-96fcf530da1c78aa4e425e6343a9dab0.png";